import { relationshipToDeceasedSchema } from "~/domains/nachlass/shared/schemas";
import { type PagesConfig } from "~/domains/pageSchemas";
import { autoSuggestStringRequiredSchema } from "~/services/validation/autoSuggest";
import { createDateInputSchema } from "~/services/validation/dateObject";
import { emailSchema } from "~/services/validation/email";
import { phoneNumberSchema } from "~/services/validation/phoneNumber";
import { schemaOrEmptyString } from "~/services/validation/schemaOrEmptyString";
import { stringOptionalSchema } from "~/services/validation/stringOptional";
import { stringRequiredSchema } from "~/services/validation/stringRequired";
import { YesNoAnswer } from "~/services/validation/YesNoAnswer";
import { addYears, today } from "~/util/date";

export const antragstellendePersonPages = {
  antragstellendePersonName: {
    stepId: "/antragstellende-person/name",
    pageSchema: {
      antragstellendePersonVorname: stringRequiredSchema,
      antragstellendePersonNachname: stringRequiredSchema,
      antragstellendePersonGeburtsname: stringOptionalSchema,
    },
  },
  antragstellendePersonGeburtsdatumOrt: {
    stepId: "/antragstellende-person/geburtsdatum-ort",
    pageSchema: {
      antragstellendePersonGeburtsdatum: createDateInputSchema({
        earliest: () => addYears(today(), -150),
        latest: () => today(),
      }),
      antragstellendePersonGeburtsort: stringRequiredSchema,
    },
  },
  antragstellendePersonStaatsangehoerigkeit: {
    stepId: "/antragstellende-person/staatsangehoerigkeit",
    pageSchema: {
      antragstellendePersonStaatsangehoerigkeit:
        autoSuggestStringRequiredSchema("nationalities"),
    },
  },
  antragstellendePersonZweiteStaatsangehoerigkeitFrage: {
    stepId: "/antragstellende-person/zweite-staatsangehoerigkeit-frage",
    pageSchema: {
      antragstellendePersonHasSecondNationality: YesNoAnswer,
    },
  },
  antragstellendePersonZweiteStaatsangehoerigkeit: {
    stepId: "/antragstellende-person/zweite-staatsangehoerigkeit",
    pageSchema: {
      antragstellendePersonZweiteStaatsangehoerigkeit:
        autoSuggestStringRequiredSchema("nationalities"),
    },
  },
  antragstellendePersonDritteStaatsangehoerigkeitFrage: {
    stepId: "/antragstellende-person/dritte-staatsangehoerigkeit-frage",
    pageSchema: {
      antragstellendePersonHasThirdNationality: YesNoAnswer,
    },
  },
  antragstellendePersonDritteStaatsangehoerigkeit: {
    stepId: "/antragstellende-person/dritte-staatsangehoerigkeit",
    pageSchema: {
      antragstellendePersonDritteStaatsangehoerigkeit:
        autoSuggestStringRequiredSchema("nationalities"),
    },
  },
  antragstellendePersonAnschrift: {
    stepId: "/antragstellende-person/anschrift",
    pageSchema: {
      antragstellendePersonStrasse: stringRequiredSchema,
      antragstellendePersonHausnummer: stringRequiredSchema,
      antragstellendePersonPlz: stringRequiredSchema,
      antragstellendePersonOrt: stringRequiredSchema,
      antragstellendePersonLand: stringRequiredSchema,
      antragstellendePersonAdresszusatz: stringOptionalSchema,
    },
  },
  antragstellendePersonKontaktdaten: {
    stepId: "/antragstellende-person/kontaktdaten",
    pageSchema: {
      antragstellendePersonTelefonnummer: phoneNumberSchema,
      antragstellendePersonEmail: schemaOrEmptyString(emailSchema),
    },
  },
  antragstellendePersonRelationshipToErblasser: {
    stepId: "/antragstellende-person/verhaeltnis",
    pageSchema: {
      antragstellendePersonRelationshipToErblasser:
        relationshipToDeceasedSchema,
    },
  },
} satisfies PagesConfig;
